












import { Vue, Component, Prop } from "vue-property-decorator"
import { Game } from "../models/game"
@Component
export default class PowerInfo extends Vue {
    @Prop(Boolean) protected unfocus: boolean
    get playerEnergy() {
        return this.$store.getters.playerEnergy
    }

    get minEnergy() {
        const state: Game = this.$store.state
        if (this.$store.state.minMwatts == null) {
            if (state.rounds != null) {
                return state.rounds[state.activeRound - 1].minEnergy
            }
        } else {
            return this.$store.state.minMwatts
        }
    }

    get pollution() {
        return this.$store.state.pollution
    }

    get pollutionThreshold() {
        return this.$store.state.pollutionThreshold
    }
}
